import { AuthenticatedTemplate, UnauthenticatedTemplate, } from "@azure/msal-react";
import { Grid, Tabs, Tab, Typography, Box, Stack } from "@mui/material";
import { useState, useEffect } from "react";
import { projectManageAxios as axios } from '../../utils/AxiosUtility';
import PropTypes from 'prop-types';
import ActivityFeed from "../../components/Notes/ActivityFeed";
import Statistics from "../../components/Statistics";
import Events from "../../components/Events/Events";
import PMTable from "../../components/ProjectManagement/PMTable";
import { useLocation } from 'react-router-dom';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: '10px', border: 1, borderRadius: '5px', borderColor: 'divider', minHeight: '70vh' }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function SecondaryTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`secondary-tabpanel-${index}`}
      aria-labelledby={`secondary-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

SecondaryTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function primaryTabProps(index) {
  return {
    id: `primary-tab-${index}`,
    'aria-controls': `primary-tabpanel-${index}`,
  };
}

function secondaryTabProps(index) {
  return {
    id: `secondary-tab-${index}`,
    'aria-controls': `secondary-tabpanel-${index}`,
  };
}

export function ProjectManageTaskSection() {
  let location = useLocation();
  const [primaryTab, setPrimaryTab] = useState(0);
  const [preSalesTab, setPreSalesTab] = useState(0);
  const [onboardingTab, setOnboardingTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [preSaleTasks, setPreSaleTasks] = useState([]);
  const [childProjectData, setChildProjectData] = useState([]);

  const handlePrimaryTabChange = (event, newValue) => {
    setPrimaryTab(newValue);
  };

  const handlePreSalesTabChange = (event, newValue) => {
    setPreSalesTab(newValue);
  };

  const handleOnboardingTabChange = (event, newValue) => {
    setOnboardingTab(newValue);
  };

  const gridItemProps = {
    //xs: 4,
    container: true,
    justifyContent: "center",
  };

  const borderStyle = {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    width: "1px",
    backgroundColor: 'black',
    margin: "0",
    height: "70%",
    transform: "translateY(25%)",
  };

  useEffect(() => {
    axios.get('api/Projects/projects')
      .then((response) => {
        setChildProjectData(response.data);
      })
      .catch((error) => {
        alert("PM Table: Error retrieving projects.");
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoading(true);
    axios.get('api/PreSales/psTasks')
      .then((response) => {
        setPreSaleTasks(response.data);
      })
      .catch((error) => {
        console.error("Error retrieving pre-sale tasks:", error);
      });
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <Grid
          container
          style={{ paddingRight: "1%", paddingLeft: "1%", height: "100%" }}
        >
          <Grid item xs={12} style={{ height: "45%", paddingTop: "0.5%" }}>
            <Stack direction="row" alignItems="center">
              <Grid item {...gridItemProps} style={{ position: "relative" }}>
                <ActivityFeed allPreLeadsFeed={primaryTab === 0} onTabChange={primaryTab} />
              </Grid>
            </Stack>
          </Grid>
          <Grid item xs={12} style={{ minHeight: "55%", paddingTop: "0.5%", paddingBottom: "0.5%" }}>
            <Box sx={{ width: "100%", border: 1, borderRadius: '5px', borderColor: 'divider' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={primaryTab} onChange={handlePrimaryTabChange}>
                  <Tab label="Pre-Sales" {...primaryTabProps(0)} />
                  <Tab label="Onboarding" {...primaryTabProps(1)} />
                </Tabs>
              </Box>

              {/* Pre-Sales Tab Content */}
              <CustomTabPanel value={primaryTab} index={0}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={preSalesTab} onChange={handlePreSalesTabChange}>
                    <Tab label="Open" {...secondaryTabProps(0)} />
                    <Tab label="Closed" {...secondaryTabProps(1)} />
                    <Tab label="Contracted" {...secondaryTabProps(2)} />
                  </Tabs>
                </Box>
                <SecondaryTabPanel value={preSalesTab} index={0}>
                  <PMTable
                    step="PreSales"
                    tab={0}
                    status={"Open"}
                    preSaleTasks={preSaleTasks}
                  />
                </SecondaryTabPanel>
                <SecondaryTabPanel value={preSalesTab} index={1}>
                  <PMTable
                    step="PreSales"
                    tab={0}
                    status={"Closed"}
                    preSaleTasks={preSaleTasks}
                  />
                </SecondaryTabPanel>
                <SecondaryTabPanel value={preSalesTab} index={2}>
                  <PMTable
                    step="PreSales" tab={0}
                    status={"Contracted"}
                    childProjectData={childProjectData}
                    preSaleTasks={preSaleTasks}
                  />
                </SecondaryTabPanel>
              </CustomTabPanel>

              {/* Onboarding Tab Content */}
              <CustomTabPanel value={primaryTab} index={1}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={onboardingTab} onChange={handleOnboardingTabChange}>
                    <Tab label="Site Prep" {...secondaryTabProps(0)} />
                    <Tab label="Coordination" {...secondaryTabProps(1)} />
                  </Tabs>
                </Box>
                <SecondaryTabPanel value={onboardingTab} index={0}>
                  <PMTable step="SitePrep" consolidatedView={true} tab={0} />
                </SecondaryTabPanel>
                <SecondaryTabPanel value={onboardingTab} index={1}>
                  <PMTable step="Coordination" consolidatedView={true} tab={1} />
                </SecondaryTabPanel>
              </CustomTabPanel>
            </Box>
          </Grid>
        </Grid>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Typography variant="h6">
          <center>Please sign-in to see your profile information.</center>
        </Typography>
      </UnauthenticatedTemplate>
    </>
  );
}
